import { useMedia } from 'react-use';

export const useIsDesktop = () => useMedia('(min-width: 768px)');
export const useIsWideDesktop = () => useMedia('(min-width: 992px)');
